import React from 'react';
import { Check, Star, BellRing } from 'lucide-react';

const PricingSection = () => {
  const plans = [
    {
      name: "Starter",
      price: "499",
      features: [
        "5 Viral Videos/Month",
        "2-3 Business Days Delivery",
        "1 Revision Per Video",
        "Retention-Optimized Editing",
        "Standard Hook Templates"
      ]
    },
    {
      name: "Growth",
      price: "1299",
      isPopular: true,
      features: [
        "15 Viral Videos/Month",
        "24-48 Hour Delivery",
        "2 Revisions Per Video",
        "Real-Time Project Tracking", // İŞTE BURADA!
        "Custom Hook & CTA Design",
        "Dedicated Account Manager",
        "A/B Testing on Hooks"
      ]
    },
    {
      name: "Authority",
      price: "2499",
      features: [
        "30 Viral Videos/Month",
        "Premium 24h Delivery",
        "Unlimited Revisions",
        "Real-Time Project Tracking", // İŞTE BURADA!
        "VIP Status Notifications",
        "Full Content Strategy",
        "Thumbnail Design Included",
        "24/7 Priority Support"
      ]
    }
  ];

  return (
    <section id="pricing" className="py-24 bg-brand-dark relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">Ready to Go <span className="text-brand-magenta">Viral?</span></h2>
          <p className="text-gray-400 text-lg">Choose the perfect plan for your content needs.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch pt-10">
          {plans.map((plan, index) => (
            <div 
              key={index} 
              className={`flex flex-col p-8 rounded-3xl border transition-all duration-300 relative ${
                plan.isPopular 
                  ? 'border-brand-magenta bg-brand-magenta/5 shadow-[0_0_30px_rgba(247,106,195,0.2)] scale-105 z-20' 
                  : 'border-white/10 bg-white/5 z-10 hover:-translate-y-2'
              }`}
            >
              {plan.isPopular && (
                <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-brand-magenta text-white px-4 py-1 rounded-full text-sm font-bold flex items-center gap-1 shadow-lg shadow-brand-magenta/30">
                  <Star size={14} fill="currentColor" />
                  MOST POPULAR
                </div>
              )}

              <div className="mb-8">
                <h3 className="text-2xl font-bold text-white mb-2">{plan.name}</h3>
                <div className="flex items-baseline gap-1">
                  <span className="text-4xl font-black text-brand-magenta">${plan.price}</span>
                  <span className="text-gray-400">/month</span>
                </div>
              </div>

              <ul className="space-y-4 mb-10 flex-grow">
                {plan.features.map((feature, fIndex) => (
                  <li key={fIndex} className="flex items-start gap-3 text-gray-200 text-left">
                    {/* Real-Time Tracking için farklı bir ikon koyalım ki parlasın */}
                    {feature.includes("Tracking") || feature.includes("Notifications") ? (
                      <BellRing className="text-brand-glow mt-1 flex-shrink-0 animate-pulse" size={18} />
                    ) : (
                      <Check className="text-brand-magenta mt-1 flex-shrink-0" size={18} />
                    )}
                    <span className={`text-sm font-medium leading-tight ${feature.includes("Tracking") ? "text-brand-glow font-bold" : ""}`}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <button 
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                className={`w-full py-4 rounded-xl font-bold transition-all mt-auto shadow-md ${
                  plan.isPopular 
                    ? 'bg-brand-magenta text-white hover:bg-brand-magenta/90 shadow-brand-magenta/20' 
                    : 'bg-white/10 text-white border border-white/20 hover:bg-white hover:text-black'
                }`}
              >
                Choose Plan
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;